import { idtype, linkTo } from "querypieces";

export default `
...on pageBuilder_pageLink_BlockType {
	${idtype}
	colors
	${linkTo}
}
`